import { render, staticRenderFns } from "./ShowToken.vue?vue&type=template&id=fa457e60"
import script from "./ShowToken.vue?vue&type=script&lang=js"
export * from "./ShowToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports